var _defs, _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#202020;}.cls-2{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_help_module") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,5.5A24.5,24.5,0,1,0,54.5,30,24.5,24.5,0,0,0,30,5.5Zm.25,37H26.13V38.63h4.12Zm4.44-13.9a15.12,15.12,0,0,1-3.08,3.29,3.85,3.85,0,0,0-1.19,1.58,7.6,7.6,0,0,0-.24,2.19h-4a8.18,8.18,0,0,1,.55-3.39,9.82,9.82,0,0,1,2.36-2.57,15.62,15.62,0,0,0,2.06-2.41,4.52,4.52,0,0,0,.76-2.55,3.41,3.41,0,0,0-.87-2.5,3.33,3.33,0,0,0-2.48-.89,3.63,3.63,0,0,0-2.34.76,2.66,2.66,0,0,0-1,2.23H21.33l0-.1a5.5,5.5,0,0,1,2-4.61A8.09,8.09,0,0,1,28.52,18,7.77,7.77,0,0,1,34,19.76a6.32,6.32,0,0,1,1.95,4.93A6.87,6.87,0,0,1,34.69,28.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.22,
    y: 0.04,
    width: 60,
    height: 60
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleHelp);
export default __webpack_public_path__ + "static/media/icon_module_help.22706f41d2effc3b745d431ae3fb616e.svg";
export { ForwardRef as ReactComponent };